import { Box, CheckBox, ColorOptions, Icon, Image, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { FlatList, View } from 'react-native'
import { useLazyApiData, useStores } from '../../data/store'
// import { SelectYourEmi } from '../SelectYourEmi'
import { useIsFocused } from '@react-navigation/native'
import { Cards } from './Cards'
import { CorporateNetBanking } from './CorporateNetBanking'
import { NetBanking } from './NetBanking'
import { PayLater } from './PayLater'
import { ListItem, Upi } from './Upi'
import { Wallet } from './Wallet'

const issueRefundData = {
  type: 'issueRefundAllowed',
  id: '1',
  title: 'Issue Refund?',
  rbData: ['Yes', 'No'],
}

const PaymentConfig = ({ type, isEdit, mid }: any) => {
  const {
    getPaymentConfigData,
    updateSelection,
    updateChecked,
    isDuplicateTxnAllowed,
    banksSelectedLength,
    walletSelectedLength,
    payLaterSelectedLength,
    isRandomTxnAllowed,
    isEmiFileUploaded,
    isCardsModified,
    merchantName,
    isEditMode,
    updateEditMode,
    emiSelectedLength,
    updateUpiConfigs,
    issueRefundAllowed,
    fetchEmsCardsList,
    getCardSchemesList,
    addedConfigurationsLength,
    deletedEntityConfigsLength,
    addedConfigValuesLength,
    deleteConfigValuesLength,
    cardsListLength,
  } = useStores((store) => ({
    getPaymentConfigData: store.onboarding.getPaymentConfigData,
    updateSelection: store.onboarding.updateSelection,
    updateChecked: store.onboarding.updateChecked,
    isDuplicateTxnAllowed: store.onboarding.upiConfig.isDuplicateTxnAllowed,
    banksSelectedLength: store.banksSelectedLength(),
    walletSelectedLength: store.walletSelectedLength(),
    payLaterSelectedLength: store.payLaterSelectedLength(),
    isRandomTxnAllowed: store.onboarding.upiConfig.isRandomTxnAllowed,
    isEmiFileUploaded: store.onboarding.isEmiFileUploaded,
    isCardsModified: store.onboarding.isCardsModified,
    merchantName: store.onboarding.merchantName,
    isEditMode: store.onboarding.isEditMode,
    updateEditMode: store.onboarding.updateEditMode,
    emiSelectedLength: store.emisSelectedLength(),
    updateUpiConfigs: store.onboarding.updateUpiConfigs,
    issueRefundAllowed: store.onboarding.issueRefundAllowed,
    paymentConfigLength: store.onboarding.paymentConfig.length,
    fetchAllLovs: store.fetchAllLovs,
    fetchEmsCardsList: store.fetchEmsCardsList,
    getCardSchemesList: store.getCardSchemesList,
    addedConfigurationsLength: store.onboarding.createdEntityConfigs.length,
    deletedEntityConfigsLength: store.onboarding.deletedEntityConfigs.length,
    addedConfigValuesLength: store?.onboarding?.createdEntityConfigs?.[0]?.configValues?.length,
    deleteConfigValuesLength: store?.onboarding?.deletedEntityConfigs?.[0]?.configValues?.length,
    cardsListLength: store?.onboarding?.cardList?.length,
  }))
  const [selectedId, setSelectedId] = useState(1)
  const [data, setData] = useState([])
  const isFocused = useIsFocused()

  const [fetchCardSchemesListApi, cardSchemesListHandler] = useLazyApiData(getCardSchemesList)

  useEffect(() => {
    if (cardSchemesListHandler.state === 'fulfilled') {
      fetchEmsCardsList(mid)
    }
  }, [cardSchemesListHandler.state, fetchEmsCardsList, mid])

  useEffect(() => {
    fetchCardSchemesListApi('110')
    updateSelection(1)
  }, [fetchCardSchemesListApi, updateSelection, isFocused])

  useEffect(() => {
    const mdata = getPaymentConfigData()
    console.log('PaymentConfig data', JSON.parse(JSON.stringify(mdata)))
    setData(mdata)
  }, [
    getPaymentConfigData,
    isDuplicateTxnAllowed,
    banksSelectedLength,
    walletSelectedLength,
    payLaterSelectedLength,
    isRandomTxnAllowed,
    isEmiFileUploaded,
    isCardsModified,
    emiSelectedLength,
    addedConfigurationsLength,
    deletedEntityConfigsLength,
    addedConfigValuesLength,
    deleteConfigValuesLength,
  ])

  const GetSelectedConfig = (id: number) => {
    const screens: any = {
      1: <Upi type={type} isEdit={isEditMode} />,
      2: <NetBanking type={type} isEdit={isEditMode} />,
      3: <Cards type={type} isEdit={isEditMode} entityId={mid} />,
      4: <Wallet type={type} isEdit={isEditMode} />,
      // 5:  <SelectYourEmi type={type} />
      6: <PayLater type={type} isEdit={isEditMode} />,
      7: <CorporateNetBanking type={type} isEdit={isEditMode} />,
    }
    return screens[id]
  }

  const renderPaymentOptions = ({ item }: any) => {
    const onItemPress = () => {
      updateSelection(item.id)
      setSelectedId(item.id)
    }
    const onItemChecked = (id: number, isChecked: boolean) => {
      console.log('onItemChecked', id, isChecked)
      updateChecked(id, isChecked)
    }
    return (
      <PaymentOptionItem item={item} onItemPress={onItemPress} onItemChecked={onItemChecked} isEditMode={isEditMode} />
    )
  }

  return (
    <>
      <ModBox show={true} f={1} overflow={'auto'} pv={32} ph={32}>
        <Box flexDirection={'row'} justifyContent={'space-between'}>
          <ModBox show={false}>
            <ListItem
              data={issueRefundData}
              updateSelection={updateUpiConfigs}
              type={type}
              isEdit={isEditMode}
              dataType={isEditMode ? 'RBG' : 'TWL'}
              value={issueRefundAllowed ?? ''}
            />
          </ModBox>
          <ModBox show={type === 'MO'}>
            <Text title={'Payment Configuration'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
            <ModBox show={type === 'EM'}>
              <Spacer size={18} direction={'vertical'} />
              <Box backgroundColor={'#FBF6EC' as ColorOptions} borderRadius={2} padding={4}>
                <Text
                  title={`Below information is fetched from Parent(${merchantName}). You may edit the information.`}
                  color={'#A97425' as ColorOptions}
                  fontSize={12}
                  fontFamily={'jiotype-medium'}
                />
              </Box>
            </ModBox>
          </ModBox>
        </Box>
        <Box
          borderWidth={1}
          borderRadius={8}
          borderColor={'#E0E0E0' as ColorOptions}
          minWidth={848}
          minHeight={472}
          marginTop={32}>
          <Box flexDirection={'row'}>
            <Box
              width={214}
              backgroundColor={'#0070B605' as ColorOptions}
              borderRightWidth={1}
              borderColor={'SEPERATOR'}
              borderBottomWidth={1}>
              <FlatList
                renderItem={renderPaymentOptions}
                data={data}
                ItemSeparatorComponent={() => (
                  <Box height={1} width={'100%'} backgroundColor={'SEPERATOR'} opacity={3} />
                )}
              />
            </Box>
            <Box height={'100%'} width={'76%'}>
              {GetSelectedConfig(selectedId)}
            </Box>
          </Box>
        </Box>
      </ModBox>
    </>
  )
}

const PaymentOptionItem = ({ item, onItemPress, onItemChecked, isEditMode }: any) => {
  const onCheckChange = (isChkd: string) => {
    console.log('PaymentOptionItem onCheckChange', isChkd)
    onItemChecked(item.id, isChkd === 'true')
  }

  return (
    <Box
      h={60}
      padding={16}
      flexDirection={'row'}
      alignItems={'center'}
      width={'100%'}
      onPress={onItemPress}
      underlayColor={'TRANSPARENT'}
      backgroundColor={item.isSelected ? ('#0070B60F' as ColorOptions) : undefined}>
      <CheckBox
        onChange={onCheckChange}
        iconSize={16}
        checked={item?.isChecked}
        color={isEditMode ? 'BLUE_SHADE_PRIMARY' : 'DISABLED_GREY'}
        disabled={!isEditMode}
      />
      <Box flexDirection={'row'}>
        <Spacer size={16} direction={'horizontal'} />
        <View style={{ width: 1, height: 24, backgroundColor: '#E0E0E0' }} />
        <Spacer size={16} direction={'horizontal'} />
        <Box flex={1} alignItems={'center'} justifyContent={'space-around'} flexDirection={'row'}>
          <ModBox show={item.icon.length === 0}>
            <Image
              source={
                item.isChecked || item.isSelected
                  ? require('../../assets/images/upi_color.png')
                  : require('../../assets/images/upi_grey.png')
              }
              width={24}
              height={24}
            />
          </ModBox>
          <ModBox show={item.icon.length > 0}>
            <Icon id={item.icon} color={item.isSelected || item.isChecked ? 'PRIMARY' : 'BLACK_75'} size={24} />
          </ModBox>
          <Spacer size={16} direction={'horizontal'} />
          <Box w={70}>
            <Text
              textAlign="left"
              title={item?.name}
              fontFamily={'jiotype-medium'}
              fontSize={12}
              color={item.isChecked || item.isSelected ? ('#0070B6' as ColorOptions) : 'BLACK_75'}
            />
          </Box>
          <Box marginRight={16}>
            <Icon
              id={'ARROW_RIGHT'}
              color={item.isSelected || item.isChecked ? 'PRIMARY' : 'DISABLED_GREY'}
              size={20}
            />
          </Box>
        </Box>
      </Box>
      <ModBox w={2} show={item.isSelected}>
        <View style={{ width: 2, height: 60, backgroundColor: '#0070B6' }} />
      </ModBox>
    </Box>
  )
}

export { PaymentConfig }
